import React , { useEffect,  useState, Component }from "react";
import "../../styles/Achat.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";
import { openKkiapayWidget, addKkiapayListener, removeKkiapayListener,} from "kkiapay";
import { useSelectedPoint } from "./SelectedPointContext";
import { FedaCheckoutButton, FedaCheckoutContainer } from 'fedapay-reactjs';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useOutletContext } from "react-router-dom";
import tente from "../../assets/tente.webp"
import Swal from "sweetalert2";
import "react-phone-input-2/lib/style.css";
import { useCart } from "../CartContext";


function Achat() {
  const lang = localStorage.getItem('language') || "FR";
  let newlang = ""; // Utilisez let au lieu de const
  const {emptyCart} = useOutletContext();
    const { cart, setCart, cartCount, setCartCount } = useCart();
  


  if (lang === "FRA" || lang === "" || lang === "FR") {
      newlang = 'FR';
  } else if (lang === "ENG") {
      newlang = 'EN';
  } else if (lang === "ESP") {
      newlang = 'ES';
  } else if (lang === "POT") {
      newlang = 'PT';
  }
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    // Supprimer l'erreur du champ modifié
    
      setErrors((prevErrors) => {
        const { isChecked: _, ...rest } = prevErrors;
        return rest;
      });
  };

  const removeItemFromCart = (id) => {
      setCart((prevCart) => {
        // Filtrer pour supprimer tous les articles avec cet ID
        const updatedCart = prevCart.filter((item) => item.id !== id);
        // Mise à jour du compteur total d'articles dans le panier
        setCartCount(updatedCart.reduce((acc, item) => acc + item.quantity, 0));
        return updatedCart;
      });
    };

  const translateText = async (text, targetLanguage) => {
    if (targetLanguage === 'FR') {
      return text; // Si la langue cible est déjà le français, ne traduisez pas.
    }
    const apiKey = process.env.REACT_APP_DEEPL_API_KEY;

    const url = process.env.REACT_APP_DEEPL_URL;


    const params = new URLSearchParams();
    params.append("auth_key", apiKey);
    params.append("text", text);
    params.append("target_lang", targetLanguage);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });


      const data = await response.json();

      if (data.translations && data.translations[0] && data.translations[0].text) {
        return data.translations[0].text;
      } else {
        return text; // Retournez le texte original si la traduction échoue
      }
    } catch (error) {
      return text; // Retournez le texte original en cas d'erreur
    }
  };


  const { t, i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language); // Changer la langue
  };

  const { selectedPointId } = useSelectedPoint();
  const [orderId, setOrderId] = useState(null);
  React.useEffect(() => {
  }, [selectedPointId]); // S'exécute à chaque changement de l'ID

const totalAmount = cart
.reduce((acc, item) => acc + item.price * item.quantity, 0)
.toLocaleString();
const totalAmounts = cart
.reduce((acc, item) => acc + item.price * item.quantity, 0)
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [country, setCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [payment_partner, setpayment_partner] = useState("FEDAPAY");
  // const [checkbox, setcheckbox] = useState("FEDAPAY");
  const [errors, setErrors] = useState({});


  // Vérifie si tous les champs sont remplis
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const handlePaymentChange = (e) => {
    setpayment_partner(e.target.value);
  };


  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSub, setIsSub] = useState(false);


  const verify_stock = async (pointId) => {



    // Préparez les IDs pour la requête
    const productIds = cart
      .filter((item) => item.type === "product")
      .map((item) => item.id.split("-")[1]);
    const ticketIds = cart
      .filter((item) => item.type === "ticket")
      .map((item) => item.id.split("-")[1]);

    // Construisez dynamiquement les paramètres de la requête
    const queryParams = [];
    if (pointId && (productIds.length > 0 || ticketIds.length > 0)) {
      queryParams.push(`sale_point_id=${pointId}`);
    }
    if (productIds.length > 0) {
      queryParams.push(`products=${productIds.join(",")}`);
    }
    if (ticketIds.length > 0) {
      queryParams.push(`tickets=${ticketIds.join(",")}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    // Déterminez l'URL
    const url = `${process.env.REACT_APP_BASE_URL}/api/shop/inventory${queryString}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": process.env.REACT_APP_API_KEY,
        },
      });
      if (!response.ok) {
        if (response.status === 500) {
          // Redirection vers la page 500
          navigate("/500");
        }
        throw new Error(`Erreur HTTP : ${response.status}`);
      }

      const data = await response.json();


      // Vérifiez les produits
      const unavailableProducts = [];
      if (productIds.length > 0) {
        data.data.products.forEach((product) => {
          const cartItem = cart.find(
            (item) =>
              item.type === "product" && item.id.split("-")[1] === String(product.id)
          );
          if (cartItem && cartItem.quantity > product.available_quantity) {
             unavailableProducts.push(product.name); 
          }
        });
      }

      // Vérifiez les tickets
      const unavailableTickets = [];
      if (ticketIds.length > 0) {

        data.data.tickets.forEach((ticket) => {
          const cartItem = cart.find(
            (item) =>
              item.type === "ticket" && item.id.split("-")[1] === String(ticket.id)
          );
          if (cartItem && cartItem.quantity > ticket.available_quantity) {
            unavailableTickets.push(ticket.name);
          }
        });
      }
      const totalTentsInCart = cart
        .filter((item) => item.type === "tent")
        .reduce((total, item) => total + item.quantity, 0);

      if (unavailableProducts.length > 0 || unavailableTickets.length > 0  || totalTentsInCart > data.data.tent_quantity) {
        let unavailableItemsMessage = "";

        // Si des produits sont indisponibles, incluez un message et réinitialisez le point
        if (unavailableProducts.length > 0) {
          unavailableItemsMessage += `${t("unavailable_items_message")}\n\n${unavailableProducts.join(", ")}\n`;
          Swal.fire({
            title: t("unavailable_items_pr_title"),
            text: unavailableItemsMessage,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
        // Si des tickets sont indisponibles, ajoutez au message (pas d'impact sur le point)
        if (unavailableTickets.length > 0) {
          unavailableItemsMessage += `${t("unavailable_items_messagetick")}\n\n${unavailableTickets.join(
            ", "
          )}`;
          Swal.fire({
            title: t("unavailable_items_tick_title"),
            text: unavailableItemsMessage,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
        const totalTentsInCart = cart
        .filter((item) => item.type === "tent")
        .reduce((total, item) => total + item.quantity, 0);

        if (totalTentsInCart > data.data.tent_quantity) {
          Swal.fire({
            title:  t("unavailable_items_tent_title"),
            text: t("unavailable_items_messagetent"),
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
        return false;
      } else {
        return true; 
      }
    } catch (error) {
      return false;
    }
  };

  const handleFieldChange = (field, value) => {
    if (field === "phone") {
      // Ne conserver que les chiffres
      const numericValue = value.replace(/\D/g, "");

      // Vérification de la longueur si le pays est le Bénin
      if (country && typeof country === "string" && country.toLowerCase() === "bj") {
        // Bloquer si le nombre de chiffres dépasse 10
        if (numericValue.length <= 10) {
          setPhone(numericValue); // Mettre à jour uniquement si la longueur est <= 10
        }
      } else {
        setPhone(numericValue); // Pour d'autres pays, autoriser la saisie sans restriction
      }
    }

    // Pour les autres champs
    if (field === "firstname") setfirstname(value);
    if (field === "lastname") setlastname(value);
    if (field === "email") setEmail(value);
    if (field === "country") setCountry(value);
    if (field === "country") setCountry(value);

   
  
    // Supprimer l'erreur du champ modifié
    if (errors[field]) {
      setErrors((prevErrors) => {
        const { [field]: _, ...rest } = prevErrors;
        return rest;
      });
    }
  };


  const handleSubmit = async (e) => {

    e.preventDefault();
    setIsSub(true);
    const handleTimeout = () => {
      setTimeout(() => {
        setIsSub(false);
      }, 5000); // 3 secondes
    };
  
    handleTimeout();
    const res = verify_stock(selectedPointId);
    if(res === false) {
      return;
    } else {


    const newErrors = {};
  
    if (!firstname) {
      newErrors.firstname = t("prenom_requis");
    } else if (!/^[a-zA-ZÀ-ÿ' -]+$/.test(firstname)) {
      newErrors.firstname = t("prenom_invalid");
    }

    if (!lastname) {
      newErrors.lastname = t("nom_requis");
    } else if (!/^[a-zA-ZÀ-ÿ' -]+$/.test(lastname)) {
      newErrors.lastname = t("nom_invalid");
    }

    if (!phone) {
      newErrors.phone = t("phone_invalid");
    } else if (country && typeof country === "string" && country.toLowerCase() === "bj") {
      const digitsOnly = phone.replace(/\D/g, ""); // Supprimer les non-chiffres
     
      if (digitsOnly.length < 5) {
        newErrors.phone = t("10_chiffres");
        setPhone(digitsOnly);
      }
    }
    
    

    if (!email) {
      newErrors.email = t("email_requis");
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    ) {
      newErrors.email = t("error_email");
    }

    if (!country) {
      newErrors.country = t("contry_no");
    }

    if (!isChecked) {
      newErrors.isChecked = t("terms_and_conditions_required");
    } else {
      setIsChecked(isChecked);
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      // Scroll vers le haut
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Ajoute un défilement fluide
      });

      // return; // Arrête l'exécution si des erreurs sont présentes
    } else{
      setErrors({});
      const cleanCartIds = (cart) => {
        return cart.map((item) => {
          const cleanedId = item.id.split("-").pop(); // Récupère la partie après le tiret
          return { ...item, id: cleanedId }; // Met à jour l'ID sans le préfixe
        });
      };

      const containsProduct = cart.some((item) => item.type === "product");

      // Crée un objet avec les données du formulaire
      const cleanedCart = cleanCartIds(cart);
      const formData = {
        sale_point_id: containsProduct ? selectedPointId : null,
        firstname,
        lastname,
        country: country ? country.label : "",
        phone,
        email,
        payment_partner,
        items: cleanedCart,
      };

      try {
        // Envoie les données au backend via une requête POST

        const response = await fetch(process.env.REACT_APP_BASE_URL+"/api/shop/submit-order", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-API-Key': process.env.REACT_APP_API_KEY,

          },
          body: JSON.stringify({ sale_point_id: selectedPointId,
              firstname: formData.firstname,
              lastname: formData.lastname,
              country: formData.country,
              phone: formData.phone,
              email: formData.email,
              payment_partner: formData.payment_partner,
              items: formData.items,
              source: "web",
            }),
        });
        if (!response.ok) {
          if (response.status === 500) {
            // Redirection vers la page 500
            navigate("/500");
          }
          throw new Error(`Erreur HTTP : ${response.status}`);
        }

        // Récupérer la réponse du backend
        const data = await response.json();
        // const transactionId = data.data.id_transaction;
        const Id_order = data.data.order_id;

        if (data.data && data.data.order_id) {
          const immediateOrderId = data.data.order_id;

          // Stocker dans le local storage
          localStorage.setItem("orderId", immediateOrderId);

          // Mettre à jour l'état pour réagir dans l'application
          setOrderId(immediateOrderId);

        }
         else {
          console.error("No order");
        }
        // Si le mode de paiement est KKIAPAY, ouvrez le widget
        if (formData.payment_partner === "KKIAPAY") {
          setIsConfirmed(true);

          // Vérifiez que la bibliothèque Kkiapay est correctement chargée
          if (typeof openKkiapayWidget === "undefined") {
            return;
          }


          // Ouvrir le widget Kkiapay avec les informations de l'utilisateur
          openKkiapayWidget({
            amount: totalAmounts,  // Montant de la transaction
            api_key: process.env.REACT_APP_KKIAPAY_API_KEY,  // Remplacer par votre clé publique Kkiapay
            sandbox: process.env.REACT_APP_KKIAPAY_SANDBOX,  // Passez à `false` en production
            email: formData.email,
            phone: formData.phone,
            firstname: formData.firstname,
            lastname: formData.lastname,
          });

          // Écoute de la réponse du paiement via le listener
          addKkiapayListener('success', async (response) => {
            setIsSubmitting(true);

            // Effectuer la vérification du paiement auprès du backend
            // await delay(30000);
            const confirmResponse = await fetch(process.env.REACT_APP_BASE_URL + "/api/shop/verify-payment", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-API-Key": process.env.REACT_APP_API_KEY,
              },
              body: JSON.stringify({
                id_transaction: response.transactionId,
                order_id: Id_order,
                payment_partner: "KKIAPAY",
              }),
            });
            if (!confirmResponse.ok) {
              if (response.status === 500) {
                // Redirection vers la page 500
                navigate("/500");
              } else {
                setIsSubmitting(false);
                toast.error(confirmData.message || t("err"), {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                });

              }
            }

            const confirmData = await confirmResponse.json();

          if (confirmData.statut === "success") {
              // Success : transaction confirmée
              localStorage.setItem("transactionData", JSON.stringify(confirmData));

              setIsSubmitting(true);
              localStorage.setItem("cart", JSON.stringify([]));
              localStorage.setItem("cartCount", "0");
              setCart([]);
              setCartCount(0);
              emptyCart();
              setIsConfirmed(true);
              navigate("/recap", { state: { confirmData }, replace: true });
            } else {
              setIsSubmitting(false);
              toast.error(confirmData.message || t("err"), {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            }
          });

          // Gérer l'échec de la transaction ou autres statuts si nécessaire
          addKkiapayListener('failure', (response) => {
            setErrorMessage( t("err"));
          });
        }

        else if (formData.payment_partner === "FEDAPAY") {
          const transactionId = data.data.id_transaction;

          setIsConfirmed(true);

          if (typeof window.FedaPay === "undefined") {
            return;
          }
          const FedaPay = window.FedaPay;

          let widget = FedaPay.init({
            public_key: process.env.REACT_APP_FEDAPAY_API_KEY,
            transaction: {
              // id: transactionId,
              amount: totalAmounts,
              description: "Paiement de la commande ",

            },
            customer: {
              firstname: formData.firstname,
              lastname: formData.lastname,
              email: formData.email,
            },
            currency: {
              iso: "XOF",
            },
            onComplete: async (resp) =>  {
              setIsSubmitting(true);
              if (resp.transaction) {
              const confirmResponse = await fetch(process.env.REACT_APP_BASE_URL+"/api/shop/verify-payment", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  'X-API-Key': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify({ id_transaction: resp.transaction.id, order_id: Id_order, payment_partner: "FEDAPAY"}),
              });
              if (resp.reason === FedaPay.DIALOG_DISMISSED) {
                setIsSubmitting(false); // Permettre un nouvel essai
                setIsConfirmed(false);  // Annuler l'état de confirmation
                setErrorMessage( t("err"));
              } else {
                    const confirmData = await confirmResponse.json();
                    // Vérifie si la transaction a réussi via le champ `statut`
                    if (confirmData.statut === "success") {
                      localStorage.setItem("transactionData", JSON.stringify(confirmData));

                      setIsSubmitting(true);

                      // Effectue des actions en cas de succès
                      localStorage.setItem("cart", JSON.stringify([]));

                      // Mettre à jour le nombre de commandes
                      localStorage.setItem("cartCount", "0");
                      setCart([]); // Vider le panier en local
                      setCartCount(0); // Mettre le nombre de commandes à 0
                      emptyCart();
                      setIsConfirmed(true); // Mettre à jour l'état de confirmation
                      navigate("/recap", { state: { confirmData }, replace: true }); // Redirection
                    }else {
                      // Échec de la validation côté serveur
                      setIsSubmitting(false);
                      toast.error(confirmData.message || t("err"), {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      });
                    }
                }
              }

            },
          });
          widget.open();
        }
      } catch (error) {
        setIsSubmitting(false);
        toast.error( t("err"), {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } finally {
        // Réactiver le bouton une fois le traitement terminé (optionnel selon votre besoin)
        setIsSubmitting(false);
      }

    }
  }

  };

  useEffect(() => {
    if (orderId) {
    }
  }, [orderId]);

const [isConfirmed, setIsConfirmed] = useState(false);
const navigate = useNavigate();
useEffect(() => {
  const storedCart = localStorage.getItem("cart"); // Récupérer les données
  if (storedCart) {
    setCart(JSON.parse(storedCart)); // Convertir en objet et mettre à jour l'état
  }
}, []);

const options = countryList().getData(); // Récupère les données des pays

const [translatedCart, setTranslatedCart] = useState([]);

const translateCartItems = async () => {
  const translatedItems = await Promise.all(
    cart.map(async (item) => {
      if (!item.name) {
        return item; // Si pas de nom, retournez l'élément tel quel
      }
      const translatedName = await translateText(item.name, newlang);
      return { ...item, name: translatedName };
    })
  );
  setTranslatedCart(translatedItems);
};


useEffect(() => {
  if (cart.length > 0) {
    translateCartItems();
  }
}, [cart, lang]);


  return (
    <div className="containero">
      <div className="payment-details">
        <h5>{t("payment_details")}</h5>
        <br/>
        <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>{t("firstname")}</label>
            <input
              type="text"
              placeholder={t("firstname_placeholder")}
              value={firstname}
              onChange={(e) => handleFieldChange("firstname", e.target.value)}
              className={errors.firstname ? "input-error" : ""}
            />
            {errors.firstname && <div className="error-message">{errors.firstname}</div>}
          </div>
          <div className="form-group">
            <label>{t("lastname")}</label>
            <input
              type="text"
              placeholder={t("lastname_placeholder")}
              value={lastname}
              onChange={(e) => handleFieldChange("lastname", e.target.value)}
              className={errors.lastname ? "input-error" : ""}
            />
            {errors.lastname && <div className="error-message">{errors.lastname}</div>}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>{t("country_of_origin")}</label>
            <Select
              options={options}
              value={country}
              onChange={(option) => handleFieldChange("country", option)}
              placeholder={t("country_placeholder")}
              className={errors.country ? "input-error" : ""}
            />
            {errors.country && <div className="error-message">{errors.country}</div>}
          </div>
          <div className="form-group">
            <label>{t("phone_number")}</label>
            <PhoneInput
              country={"bj"} // Pays par défaut
              value={phone}
              masks={{ bj: '.. .. .. .. ..' }}
              onChange={(value) => handleFieldChange("phone", value)} // Utilisez handleFieldChange
              inputStyle={{
                width: "100%",
                height: "38px",
                borderRadius: "5px",
                border: "1px solid #ced4da",
                paddingLeft: "45px", // Ajuster pour l'espace du drapeau
              }}
              dropdownStyle={{
                borderRadius: "5px",
                border: "1px solid #ced4da",
              }}
            />
            {errors.phone && <div className="error-message">{errors.phone}</div>}
          </div>
        </div>
        <div className="form-group">
          <label>{t("email")}</label>
          <input
            type="email"
            placeholder={t("email_placeholder")}
            value={email}
            onChange={(e) => handleFieldChange("email", e.target.value)}
            className={errors.email ? "input-error" : ""}
          />
          {errors.email && <div className="error-message">{errors.email}</div>}
        </div>
        <label className="check" style={{display: "block"}}>
          <input
            type="checkbox"
            value={isChecked}
            onChange={(e) => handleCheckboxChange(e)}
            style={{ marginRight: "8px" }}
          />
          {t("accept_terms_and_conditions")}
          <a 
            href="/Conditions_Générales_de_Vente.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: " ", textDecoration: "none" }}
          >
            {t("conditions_générales_de_vente")}
          </a>
          &nbsp;{t("de Vodun Days")}
        </label>
        {errors.isChecked && <div className="error-message">{errors.isChecked}</div>}
      </form>


      <br/>
      <hr></hr>
      <p className="agregator"> {t("agreg")}
      </p>

    </div>
      <div className="order-summary">
        <h5> {t("your_order")}</h5>
        <hr />
        <div>
        {/* Boucle pour afficher les articles du panier */}
        {translatedCart.length > 0 && cart.length > 0 ? (
          translatedCart.map((item, index) => (
            <div key={index} className="cart-item">
              <div className="le">
              {item.type === "tent" || item.type === "tenda"  || item.type === "tienda"  ? (
                        <img
                          src= {tente} // Remplacez par le chemin réel de votre image
                          alt="Tent"
                          className="item-imge"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}/${item.img}`}
                          alt={item.name}
                          className="item-imge"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      )}

              <div className="note">
                {item.name}{/*Nom du produit*/}
              </div>
              </div>
              <div className="ri">
                <div className="prix"> {item.quantity} x  {Number(item.price).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} FCFA </div>


                {/* <div className="prix">{(item.price * item.quantity).toLocaleString()}  FCFA</div> Total pour l'article */}
              </div>
            </div>
          ))
        ) : (
          <p> {t("cart_empty")}</p> // Affichage par défaut si le panier est vide
        )}
      </div>
        <div className="order-summary-details">

          <hr className="summtotl"/>
          <div className="summary-item">
            <span className="summtot">{t("total")}</span>
            <span className="summary-item1">{totalAmount}  FCFA</span>
          </div>
        </div>
        <div>
        <div className="payment-option">
          <label>
            <input
              type="radio"
              name="payment"
              value="FEDAPAY"
              checked={payment_partner === "FEDAPAY"}
              onChange={handlePaymentChange}
            />{" "}
            FEDAPAY
          </label>
          {payment_partner === "FEDAPAY" && (
            <p className="payment-message">  {t("payment_by")} FEDAPAY</p>
          )}
        </div>
        <div className="payment-option">
          <label>
            <input
              type="radio"
              name="payment"
              value="KKIAPAY"
              checked={payment_partner === "KKIAPAY"}
              onChange={handlePaymentChange}
            />{" "}
            KKIAPAY
          </label>
          {payment_partner === "KKIAPAY" && (
            <p className="payment-message">{t("payment_by")} KKIAPAY</p>
          )}
        </div>
      </div>


      <button
        className="payment-button"
        type="button"
        onClick={handleSubmit}
        disabled={isSubmitting || isSub || cart.length === 0 || cartCount === 0 }
      >
        {t("proceed_to_payment")}
      </button>
      {isSubmitting && (
        <div className="loading-screen">
          <div className="spinner"></div>
        </div>
      )}
      {showErrorPopup && (
      <div className="popup-overlay">
        <div className="popup">
          <h3>{t("form_error")}</h3>
          <p>{errorMessage}</p>
          <button onClick={() => setShowErrorPopup(false)}>
            {t("close")}
          </button>
        </div>
      </div>
      )}
      </div>
    </div>
  );
}

export default Achat;